export default __webpack_public_path__ + "static/media/logo.cfe08bc0.png";